import axios from "axios";
import { API_BASE_URL, getAuthToken } from "./shared";

// API helpers for Terms & Disclosures (FSD 6.8.4). The artist is always the signed-in user.
const url = (path = "") => `${API_BASE_URL}/v1/artist-terms${path}`;
const config = () => ({ headers: { token: getAuthToken(), "Content-Type": "application/json" }, timeout: 15000 });
const result = (response) => response.data?.result;

export const termsApi = {
  // { documents: [{ code, title, summary, version, effective_at, requires_acceptance, downloadable, accepted, accepted_version, accepted_at, needs_acceptance }], reaccept_required }
  list: () => axios.get(url(), config()).then(result),
  // One document with its full text in `content`.
  get: (code) => axios.get(url(`/${encodeURIComponent(code)}`), config()).then(result),
  // documents: [{ code, version }] - the version must be the one the artist just read. Answers the refreshed list.
  accept: (documents) => axios.post(url("/accept"), { documents }, config()).then(result),
};
